import {LangArrayToObjKeyValue} from '../../../utils/global'
import {AiOutlineEdit} from 'react-icons/ai'
import {RiDeleteBin6Line} from 'react-icons/ri'
import { useCurrent } from '../../../hooks';
import { useTranslation } from 'react-i18next';
import { getBooleanBadgeClassName } from '../productUi';

const ListTagsItem = ({index,el,editHandeler,deleteHandeler}) => {
  const {currentLangId} = useCurrent();
  const [t] = useTranslation('global')
  const tagName = LangArrayToObjKeyValue(el.tagName)?.[currentLangId] ;

  return (
    <div key={el._id} className='my-1 flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-3 transition-colors hover:bg-[#251658]/5'>
        <div className='w-12 text-center text-slate-500'>{index}</div>
        <div className='flex-1 px-2 font-medium text-slate-700'><span>{tagName}</span></div>
        <div className={`w-20 rounded-full px-2 py-1 text-center text-xs ${getBooleanBadgeClassName(el.isActive)}`}>{el.isActive ? t('product.active') : t('product.inactive')}</div>
        <div className='w-8 cursor-default text-center text-[#251658] transition-colors hover:text-[#140c32]' onClick={()=>editHandeler(el._id)}><AiOutlineEdit size={18}/></div>
        <div className='w-8 cursor-default text-center text-[#251658] transition-colors hover:text-[#140c32]' onClick={()=>deleteHandeler(el._id)}><RiDeleteBin6Line size={18} /></div>
      </div>
  )
}

export default ListTagsItem
